import React, { useState, useEffect, useContext, useRef } from 'react';
import { Modal, Form, Row, Col, InputGroup, Button, Spinner, Accordion, Table, Image } from 'react-bootstrap';
import logorect from '../img/logorect.png';
import logosquire from '../img/logosquire.png';
import $ from 'jquery';
import 'jquery-confirm';
import { AppContext } from '../App';


export const MainNavbar = () => {
	const { setPage, user, page, getCall, postCall, postFile, setGetLoad, getPermissions, getStaffTypes, getStaffs, getServices, getCustomers, getEnquiry, getPayModes,
		getTokens, getTokenServices, getTokenCustomers, getPaymentMethods, closeDayState, setAuthForm, accessToken, dayClose, setExpense, setLoad, setReOpenRepo,
		setDayClose, getCollections, getNotifications, closeDayReport, setCloseDayReport, getSpecialTokens, account, setExpenseParti, setPettyExpense, setExpenseReport,
		setAccount, getDayCloseToVerify, getCredits, getQuickReport, getCustomerReport, getServiceReport, getStaffReport, payWalletReport, setPayWalletReport,
		getCollectionReport, getCreditReport, getDetailReport, getCancelReport, getHomePage, getSpecialBills, getQuickReportToday, setPayWallet, setWalletCus,
		getWorks, getSubmitted, stateSettle, stateSettleAll, getQuickReportYear, setStaffTokenReport, getDate, setDetailTreport, setIncompleteTokenReport,
		setSalaryStaff, setAttendence, setSmDiStaffs, setSalaryCalcRepo, setSalaryPayRepo, setEnquiryTypes, setLeads,
		setDayCloseReportModal, setGetDayReportload } = useContext(AppContext);

	const [dayCloseModal, setDayCloseModal] = useState(false);
	const [dayCloseState, setDayCloseState] = useState('denomination');
	const [addDenominationLoad, setAddDenominationLoad] = useState(false);
	const addDenominations = (e) => {
		e.preventDefault();
		let n_500 = e.target.n_500.value;
		let n_200 = e.target.n_200.value;
		let n_100 = e.target.n_100.value;
		let n_50 = e.target.n_50.value;
		let n_20 = e.target.n_20.value;
		let n_10 = e.target.n_10.value;
		let n_5 = e.target.n_5.value;
		let n_2 = e.target.n_2.value;
		let n_1 = e.target.n_1.value;
		let open = e.target.opening.value;
		if (n_500 !== "" || n_200 !== "" || n_100 !== "" || n_50 !== "" || n_20 !== "" || n_10 !== "" || n_5 !== "" || n_2 !== "" || n_1 !== "") {
			$.confirm({
				title: 'Confirm Day Close!',
				content: 'Are you sure you want to close day?',
				type: 'blue',
				typeAnimated: true,
				buttons: {
					confirm: {
						text: 'Confirm',
						btnClass: 'btn-blue',
						action: function () {
							setAddDenominationLoad(true);
							postCall('api/pnp/day/close/', {
								n_500: n_500,
								n_200: n_200,
								n_100: n_100,
								n_50: n_50,
								n_20: n_20,
								n_10: n_10,
								n_5: n_5,
								n_2: n_2,
								n_1: n_1,
								opening_balance: open,
							}).then((response) => {
								setAddDenominationLoad(false);
								setDayClose(false);
								if (response.data.main.diffrence === 0) {
									setDayCloseModal(false);
								} else {
									setDayCloseState('addReason');
									setCloseDayReport(response.data);
								}
							}).catch((err) => {
								setAddDenominationLoad(false);
							});
						}
					},
					cancel: function () {
					}
				}
			});
		}
	}
	const [reasonSubmitLoad, setReasonSubmitLoad] = useState(false);
	const submitReason = (e) => {
		e.preventDefault();
		let reason = e.target.reason.value;
		if (reason !== "") {
			setReasonSubmitLoad(true);
			postCall('api/pnp/day/close/reason/', { reason: reason }).then((response) => {
				setReasonSubmitLoad(false);
				setDayCloseModal(false);
			}).catch((err) => {
				setReasonSubmitLoad(false);
			});
		}
	}
	const getDayReport = () => {
		setDayCloseReportModal(true);
		getCall(setGetDayReportload, 'api/pnp/day/close/user/report/', setCloseDayReport);
	}
	const [profileModal, setProfileModal] = useState(false);
	const [profileUpdateLoad, setProfileUpdateLoad] = useState(false);
	const [nameReqErr, setNameReqErr] = useState(false);
	const [emailReqErr, setEmailReqErr] = useState(false);
	const [changeLogo, setChangeLogo] = useState(false);
	useEffect(() => {
		if (account !== undefined) {
			if (account.logo === "") {
				setChangeLogo(true);
			} else {
				setChangeLogo(false);
			}
		}
	}, [account]);
	const [logoReqErr, setLogoReqErr] = useState(false);
	const [addressReqErr, setAddressReqErr] = useState(false);
	const [contactReqErr, setContactReqErr] = useState(false);
	const postProfile = (logo, name, address, contact, email) => {
		setProfileUpdateLoad(true);
		const formData = new FormData();
		if (logo) formData.append('file', logo);
		formData.append('name', name);
		formData.append('address', address);
		formData.append('phone', contact);
		formData.append('email', email);

		postCall('api/pnp/update/account/', formData).then((response) => {
			setProfileUpdateLoad(false);
			setAccount(response.data.account);
			setProfileModal(false);
		}).catch((err) => {
			setProfileUpdateLoad(false);
		});
	}
	const updateProfile = (e) => {
		e.preventDefault();
		let name = e.target.name.value;
		let address = e.target.address.value;
		let contact = e.target.contact.value;
		let logo = '';
		if (changeLogo) {
			logo = e.target.logo.files[0];
		}
		let email = e.target.email.value;
		if (name === "") {
			setNameReqErr(true);
			setTimeout(() => { setNameReqErr(false) }, 5000);
		}
		if (email === "") {
			setEmailReqErr(true);
			setTimeout(() => { setEmailReqErr(false) }, 5000);
		}
		if (changeLogo) {
			if (logo === undefined || logo === "") {
				setLogoReqErr(true);
				setTimeout(() => { setLogoReqErr(false) }, 5000);
			}
		}
		if (address === "") {
			setAddressReqErr(true);
			setTimeout(() => { setAddressReqErr(false) }, 5000);
		}
		if (contact === "") {
			setContactReqErr(true);
			setTimeout(() => { setContactReqErr(false) }, 5000);
		}
		if (changeLogo) {
			if (name !== "" && email !== "" && logo !== undefined && logo !== "" && address !== "" && contact !== "") {
				postProfile(logo, name, address, contact, email);
			}
		} else {
			if (name !== "" && email !== "" && address !== "" && contact !== "") {
				postProfile(logo, name, address, contact, email);
			}
		}
	}
	const [changePasswordModal, setChangePasswordModal] = useState(false);
	const [npassError, setNpassError] = useState(false);
	const [ncpassError, setNcpassError] = useState(false);
	const [npassEqualError, setNpassEqualError] = useState(false);
	const [changePassLoad, setChangePassLoad] = useState(false);
	const [alertPassChange, setAlertPassChange] = useState('default');
	const changePassword = (e) => {
		e.preventDefault();
		let pass = e.target.pass.value;
		let cpass = e.target.cpass.value;
		if (pass === "") {
			setNpassError(true);
			setTimeout(() => { setNpassError(false) }, 5000);
		}
		if (cpass === "") {
			setNcpassError(true);
			setTimeout(() => { setNcpassError(false) }, 5000);
		}
		if (pass !== "" && cpass !== "" && pass !== cpass) {
			setNpassEqualError(true);
			setTimeout(() => { setNpassEqualError(false) }, 5000);
		}
		if (pass !== "" && cpass !== "" && pass === cpass) {
			setChangePassLoad(true);
			postCall('api/pnp/update/profile/password/', { password: pass }).then((response) => {
				setChangePassLoad(false);
				setAlertPassChange('sucess');
				setTimeout(() => {
					setAlertPassChange('default');
					setChangePasswordModal(false);
				}, 3000);
			}).catch((err) => {
				setChangePassLoad(false);
				setAlertPassChange('error');
				setTimeout(() => {
					setAlertPassChange('default');
				}, 3000);
			});
		}
	}

	const navbarRef = useRef();

	const handleNavItemClick = (callback) => {
		if (typeof callback === 'function') callback();
		// Collapse the navbar if open (for mobile)
		if (navbarRef.current) {
			const collapse = navbarRef.current.querySelector('.navbar-collapse');
			if (collapse && collapse.classList.contains('show')) {
				collapse.classList.remove('show');
			}
		}
	};

	// State to control sidebar toggle on mobile
	const [isOpen, setIsOpen] = useState(false);
	const toggleSidebar = () => setIsOpen(!isOpen);

	// State for desktop sidebar collapse
	const [isCollapsed, setIsCollapsed] = useState(false);
	const toggleCollapse = () => {
		setIsCollapsed(!isCollapsed);
		if (!isCollapsed) setActiveSubMenu('');
	};

	// Determine which dropdown is open
	const [activeSubMenu, setActiveSubMenu] = useState('');

	const toggleSubMenu = (menuName) => {
		if (activeSubMenu === menuName) {
			setActiveSubMenu('');
		} else {
			setActiveSubMenu(menuName);
		}
	}

	const handleSidebarItemClick = (callback) => {
		if (typeof callback === 'function') callback();
		// On mobile, close sidebar after click
		if (window.innerWidth < 992) {
			setIsOpen(false);
		}
	};

	// Helper to auto-expand if clicking a group while collapsed
	const handleGroupClick = (menuName) => {
		if (isCollapsed) {
			setIsCollapsed(false);
			setTimeout(() => toggleSubMenu(menuName), 50);
		} else {
			toggleSubMenu(menuName);
		}
	}

	return (
		<>
			{/* Mobile Header */}
			<div className="mobile-header d-lg-none">
				<div className="mobile-brand bg-white" onClick={() => {
					handleSidebarItemClick(() => {
						getHomePage();
						setPage('dashboard');
					});
				}}><Image src={logorect} style={{ width: '150px' }} /></div>
				<button className="mobile-toggle-btn" onClick={toggleSidebar}>
					<i className="bi bi-list"></i>
				</button>
			</div>

			{/* Sidebar Container */}
			<div className={`sidebar-menu ${isOpen ? 'show' : ''} ${isCollapsed ? 'collapsed' : ''}`}>
				<div className="sidebar-container">
					<div className="sidebar-header d-none d-lg-flex bg-white p-2">
						<div className={`sidebar-brand d-none d-lg-block ${isCollapsed ? 'collapsed-brand' : ''}`} onClick={() => {
							handleSidebarItemClick(() => {
								getHomePage();
								setPage('dashboard');
							});
						}}>
							{isCollapsed ? <Image src={logosquire} style={{ width: '30px' }} /> : <Image src={logorect} style={{ width: '130px' }} />}
						</div>
						<button className="collapse-btn d-none d-lg-block ms-auto bg-transparent border-0" onClick={toggleCollapse}>
							<i className={`bi ${isCollapsed ? 'bi-list' : 'bi-text-indent-right'}`} style={{ fontSize: '1.5rem' }}></i>
						</button>
					</div>


					<div className="sidebar-content">
						<div className={`sidebar-item ${page === 'dashboard' ? 'active' : ''}`} onClick={() => {
							handleSidebarItemClick(() => {
								getHomePage();
								setPage('dashboard');
							});
						}}>
							<i className="bi bi-house-door me-2"></i> <span>Home</span>
						</div>

						{/* Token */}
						{
							(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.token !== undefined && Object.values(user.permission.token).indexOf(true) !== -1) ? (
								<div className={`sidebar-item ${page === 'token' ? 'active' : ''}`} onClick={() => {
									handleSidebarItemClick(() => {
										setPage('token');
										getTokens();
										getTokenServices();
										getTokenCustomers();
										getPayModes();
										getCall(setGetLoad, 'api/pw/get/wallet/billing/', setPayWallet);
									});
								}}>
									<i className="bi bi-ticket-perforated me-2"></i> <span>Token</span>
								</div>
							) : ''
						}

						{/* Cashier */}
						{
							(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.token_settle !== undefined && user.permission.token_settle.X) ? (
								<div className={`sidebar-item ${page === 'cashier' ? 'active' : ''}`} onClick={() => {
									handleSidebarItemClick(() => {
										setPage('cashier');
										getPayModes();
										getSubmitted();
									});
								}}>
									<i className="bi bi-cash-coin me-2"></i> <span>Cashier</span>
								</div>
							) : ''
						}

						{/* Credits */}
						{
							(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.credit !== undefined && Object.values(user.permission.credit).indexOf(true) !== -1) ? (
								<div className={`sidebar-item ${page === 'credits' ? 'active' : ''}`} onClick={() => {
									handleSidebarItemClick(() => {
										setPage('credits');
										getTokenServices();
										getTokenCustomers();
										getCredits();
										getPayModes();
									});
								}}>
									<i className="bi bi-credit-card me-2"></i> <span>Credits</span>
								</div>
							) : ''
						}

						{/* Staff Dropdown */}
						{
							user !== undefined ? (
								user.type === 'admin' ? (
									<div className="sidebar-dropdown-group">
										<div className={`sidebar-item has-submenu ${activeSubMenu === 'staff' ? 'active' : ''}`} onClick={() => handleGroupClick('staff')}>
											<i className="bi bi-people me-2"></i> <span>Staff</span>
											<i className={`bi bi-chevron-down ms-auto transition-icon ${activeSubMenu === 'staff' ? 'rotate-180' : ''}`}></i>
										</div>
										<div className={`sidebar-submenu ${activeSubMenu === 'staff' ? 'show' : ''}`}>
											<div className="sidebar-subitem" onClick={() => {
												handleSidebarItemClick(() => {
													setPage('staff_type');
													getPermissions();
													getStaffTypes();
												});
											}}>Staff Types & Permissions</div>
											<div className="sidebar-subitem" onClick={() => {
												handleSidebarItemClick(() => {
													setPage('staffs');
													getStaffTypes();
													getStaffs();
												});
											}}>Manage Staffs</div>
										</div>
									</div>
								) : (
									user.permission.staff !== undefined ? (
										Object.values(user.permission.staff).indexOf(true) !== -1 || Object.values(user.permission.staff_type).indexOf(true) !== -1 ? (
											<div className="sidebar-dropdown-group">
												<div className={`sidebar-item has-submenu ${activeSubMenu === 'staff' ? 'active' : ''}`} onClick={() => handleGroupClick('staff')}>
													<i className="bi bi-people me-2"></i> <span>Staff</span>
													<i className={`bi bi-chevron-down ms-auto transition-icon ${activeSubMenu === 'staff' ? 'rotate-180' : ''}`}></i>
												</div>
												<div className={`sidebar-submenu ${activeSubMenu === 'staff' ? 'show' : ''}`}>
													{
														Object.values(user.permission.staff_type).indexOf(true) !== -1 ? (
															<div className="sidebar-subitem" onClick={() => {
																handleSidebarItemClick(() => {
																	setPage('staff_type');
																	getPermissions();
																	getStaffTypes();
																});
															}}>Staff Types & Permissions</div>
														) : ''
													}
													{
														Object.values(user.permission.staff).indexOf(true) !== -1 ? (
															<div className="sidebar-subitem" onClick={() => {
																handleSidebarItemClick(() => {
																	setPage('staffs');
																	getStaffTypes();
																	getStaffs();
																});
															}}>Manage Staffs</div>
														) : ''
													}
												</div>
											</div>
										) : ''
									) : ''
								)
							) : ''
						}

						{/* Salary Management */}
						<div className='sidebar-item' style={{ cursor: 'not-allowed', opacity: 0.5 }}>
							<i className="bi bi-wallet2 me-2"></i> <span>Salary Mgmt</span>
						</div>
						{/* {
							(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.salary !== undefined && Object.values(user.permission.salary).indexOf(true) !== -1) ? (
								<div className="sidebar-dropdown-group disabled">
									<div className={`sidebar-item has-submenu ${activeSubMenu === 'salary' ? 'active' : ''}`} onClick={() => handleGroupClick('salary')}>
										<i className="bi bi-wallet2 me-2"></i> <span>Salary Mgmt</span>
										<i className={`bi bi-chevron-down ms-auto transition-icon ${activeSubMenu === 'salary' ? 'rotate-180' : ''}`}></i>
									</div>
									<div className={`sidebar-submenu ${activeSubMenu === 'salary' ? 'show' : ''}`}>
										<div className="sidebar-subitem" onClick={() => {
											handleSidebarItemClick(() => {
												setPage('salary-saff');
												getCall(setLoad, 'api/sm/get/staffs/', setSalaryStaff);
											});
										}}>Staffs</div>
										<div className="sidebar-subitem" onClick={() => {
											handleSidebarItemClick(() => {
												setPage('staff-attandence');
											});
										}}>Attendance</div>
										<div className="sidebar-subitem" onClick={() => {
											handleSidebarItemClick(() => {
												setPage('staff-disabled');
												getCall(setLoad, 'api/sm/get/disabled/staffs/', setSmDiStaffs);
											});
										}}>Disabled Staffs</div>
									</div>
								</div>
							) : ''
						} */}

						{/* Services */}
						{
							(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.service !== undefined && Object.values(user.permission.service).indexOf(true) !== -1) ? (
								<div className={`sidebar-item ${page === 'services' ? 'active' : ''}`} onClick={() => {
									handleSidebarItemClick(() => {
										setPage('services');
										getServices();
									});
								}}>
									<i className="bi bi-gear me-2"></i> <span>Services</span>
								</div>
							) : ''
						}

						{/* Collection */}
						{
							(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.collection !== undefined && Object.values(user.permission.collection).indexOf(true) !== -1) ? (
								<div className={`sidebar-item ${page === 'collections' ? 'active' : ''}`} onClick={() => {
									handleSidebarItemClick(() => {
										setPage('collections');
										getCollections(getDate());
									});
								}}>
									<i className="bi bi-collection me-2"></i> <span>Collection</span>
								</div>
							) : ''
						}

						{/* Enquiry & Works */}
						{/* <div className='sidebar-item' style={{ cursor: 'not-allowed', opacity: 0.5 }} onClick={() => { }}>
							<i className="bi bi-question-circle me-2"></i> <span>Enquiry</span>
						</div> */}
						{
							(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.enquiry !== undefined && Object.values(user.permission.enquiry).indexOf(true) !== -1) ? (
								<>
									<div className={`sidebar-item ${page === 'enquiry' ? 'active' : ''}`} onClick={() => {
										handleSidebarItemClick(() => {
											setPage('enquiry');
											getCall(setGetLoad, 'api/e/get/enquiry/types/', setEnquiryTypes);
											getEnquiry();
											getCustomers();
										});
									}}>
										<i className="bi bi-question-circle me-2"></i> <span>Enquiry</span>
									</div>
									<div className={`sidebar-item ${page === 'works' ? 'active' : ''}`} onClick={() => {
										handleSidebarItemClick(() => {
											setPage('works');
											getWorks();
											getCustomers();
										});
									}}>
										<i className="bi bi-briefcase me-2"></i> <span>Works</span>
									</div>
								</>
							) : ''
						}

						{/* Notifications */}
						{
							(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.notification !== undefined && Object.values(user.permission.notification).indexOf(true) !== -1) ? (
								<div className={`sidebar-item ${page === 'notification' ? 'active' : ''}`} onClick={() => {
									handleSidebarItemClick(() => {
										getNotifications();
										setPage('notification');
									});
								}}>
									<i className="bi bi-bell me-2"></i> <span>Notifications</span>
								</div>
							) : ''
						}

						{/* Customers */}
						{
							(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.customer !== undefined && Object.values(user.permission.customer).indexOf(true) !== -1) ? (
								<div className={`sidebar-item ${page === 'customers' ? 'active' : ''}`} onClick={() => {
									handleSidebarItemClick(() => {
										setPage('customers');
										getCustomers();
									});
								}}>
									<i className="bi bi-person me-2"></i> <span>Customers</span>
								</div>
							) : ''
						}

						{/* Wallet */}
						<div className={`sidebar-item ${page === 'c-wallet' ? 'active' : ''}`} onClick={() => {
							handleSidebarItemClick(() => {
								setPage('c-wallet');
								getCustomers();
								getCall(setGetLoad, 'api/ap/get/wallet/', setWalletCus);
								getPayModes();
							});
						}}>
							<i className="bi bi-wallet me-2"></i> <span>Customer Wallet</span>
						</div>

						{/* Expense */}
						<div className="sidebar-dropdown-group">
							<div className={`sidebar-item has-submenu ${activeSubMenu === 'expense' ? 'active' : ''}`} onClick={() => handleGroupClick('expense')}>
								<i className="bi bi-calculator me-2"></i> <span>Expense</span>
								<i className={`bi bi-chevron-down ms-auto transition-icon ${activeSubMenu === 'expense' ? 'rotate-180' : ''}`}></i>
							</div>
							<div className={`sidebar-submenu ${activeSubMenu === 'expense' ? 'show' : ''}`}>
								<div className={`sidebar-subitem ${page === 'petty-exp' ? 'active' : ''}`} onClick={() => {
									handleSidebarItemClick(() => {
										setPage('petty-exp');
										getPayModes();
										getCall(setGetLoad, 'api/em/get/expense/particular/', setExpenseParti);
										getCall(setLoad, 'api/em/get/petty/expense/', setPettyExpense);
									});
								}}>Petty Expense</div>
								{
									(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.expense !== undefined && Object.values(user.permission.expense).indexOf(true) !== -1) ? (
										<div className={`sidebar-subitem ${page === 'exp-add' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setPage('exp-add');
												getPayModes();
												getCall(setGetLoad, 'api/em/get/expense/particular/', setExpenseParti);
												getCall(setLoad, 'api/em/get/expense/', setExpense);
											});
										}}>Expense</div>
									) : ''
								}
							</div>
						</div>
						{/* Reports */}
						{
							(user !== undefined && user.type === 'admin') || (user !== undefined && user.permission.report !== undefined && Object.values(user.permission.report).indexOf(true) !== -1) ? (
								<div className="sidebar-dropdown-group">
									<div className={`sidebar-item has-submenu ${activeSubMenu === 'reports' ? 'active' : ''}`} onClick={() => handleGroupClick('reports')}>
										<i className="bi bi-file-earmark-text me-2"></i> <span>Reports</span>
										<i className={`bi bi-chevron-down ms-auto transition-icon ${activeSubMenu === 'reports' ? 'rotate-180' : ''}`}></i>
									</div>
									<div className={`sidebar-submenu ${activeSubMenu === 'reports' ? 'show' : ''}`}>
										<div className={`sidebar-subitem ${page === 'quick_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												getQuickReport();
												setPage('quick_report');
												getQuickReportToday();
												getQuickReportYear();
											});
										}}>Quick Report</div>
										<div className={`sidebar-subitem ${page === 'collection_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												getCollectionReport();
												setPage('collection_report');
											});
										}}>Collection report</div>
										<div className={`sidebar-subitem ${page === 'credit_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												getCreditReport();
												setPage('credit_report');
											});
										}}>Credit report</div>
										<div className={`sidebar-subitem ${page === 'credit_collection_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setPage('credit_collection_report');
											});
										}}>Credit collection report</div>
										<div className={`sidebar-subitem ${page === 'token_cancel_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												getCancelReport();
												setPage('token_cancel_report');
											});
										}}>Token Cancellation report</div>
										<div className={`sidebar-subitem ${page === 'customer_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												getCustomerReport();
												setPage('customer_report');
											});
										}}>Customer wise invoice report</div>
										<div className={`sidebar-subitem ${page === 'staff_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												getStaffReport();
												setPage('staff_report');
											});
										}}>Staff wise invoice report</div>
										<div className={`sidebar-subitem ${page === 'service_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												getServiceReport();
												setPage('service_report');
											});
										}}>Service wise invoice report</div>
										<div className={`sidebar-subitem ${page === 'detailed_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												getDetailReport();
												setPage('detailed_report');
											});
										}}>Detailed invoice report</div>
										{/* <div className={`sidebar-subitem ${page === 'staff_token_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setGetLoad(true)
												postCall('api/bnr/get/staff/token/report/', { start_date: getDate(), end_date: getDate() }).then(res => {
													setStaffTokenReport(res.data);
													setGetLoad(false);
												}).catch(err => {
													setGetLoad(false);
												});
												setPage('staff_token_report');
											});
										}}>Staff token report</div>
										<div className={`sidebar-subitem ${page === 'detailed_token_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setGetLoad(true)
												postCall('api/bnr/get/detailed/token/report/', { start_date: getDate(), end_date: getDate(), staff_id: "", service_id: "" }).then(res => {
													setDetailTreport(res.data);
													setGetLoad(false);
												}).catch(err => {
													setGetLoad(false);
												});
												setPage('detailed_token_report');
											});
										}}>Detailed token report</div> */}
										<div className={`sidebar-subitem ${page === 'incomplete_token_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setGetLoad(true)
												postCall('api/bnr/get/not/completed/token/report/', { start_date: getDate(), end_date: getDate() }).then(res => {
													setIncompleteTokenReport(res.data);
													setGetLoad(false);
												}).catch(err => {
													setGetLoad(false);
												});
												setPage('incomplete_token_report');
											});
										}}>Incomplete token report</div>
										<div className={`sidebar-subitem ${page === 'expense_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setLoad(true);
												getCall(setGetLoad, 'api/em/get/expense/particular/', setExpenseParti);
												postCall('api/bnr/get/expense/report/', { start_date: getDate(), end_date: getDate(), staff_id: '', p_id: '' }).then(res => {
													setExpenseReport(res.data);
													setLoad(false);
												}).catch(err => {
													setLoad(false);
												});
												setPage('expense_report');
											});
										}}>Expense report</div>
										<div className={`sidebar-subitem ${page === 'pay_wallet_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setGetLoad(true);
												getCall(setGetLoad, 'api/pw/get/wallet/billing/', setPayWallet);
												getStaffs();
												postCall('api/bnr/get/payment/wallet/report/', { start_date: getDate(), end_date: getDate(), staff_id: '', wallet_id: '' }).then(res => {
													setPayWalletReport(res.data);
													setGetLoad(false);
												}).catch(err => {
													setGetLoad(false);
												});
												setPage('pay_wallet_report');
											});
										}}>Payment wallet report</div>
										<div className={`sidebar-subitem ${page === 'cus_wallet_report' ? 'active' : ''}`} onClick={() => {
											setPage('cus_wallet_report');
										}}>Customer wallet report</div>
										{/* <div className={`sidebar-subitem ${page === 'reopen_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setLoad(true);
												postCall('api/bnr/get/verify/reopen/report/', { start_date: getDate(), end_date: getDate(), staff_id: '' }).then(res => {
													setReOpenRepo(res.data);
													setLoad(false);
												}).catch(err => {
													setLoad(false);
												});
												setPage('reopen_report');
											});
										}}>Day close re-open report</div> */}
										<div className={`sidebar-subitem ${page === 'day_close_report' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setPage('day_close_report');
											});
										}}>Day close report</div>
										<div className='sidebar-subitem' style={{ opacity: '0.5', cursor: 'not-allowed' }} >Salary calculation report</div>
										<div className='sidebar-subitem' style={{ opacity: '0.5', cursor: 'not-allowed' }} >Salary Payment report</div>
										{/* <div className={`sidebar-subitem ${page === 'report_salary_calc' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setLoad(true);
												postCall('api/bnr/get/salary/calculation/report/', { start_date: getDate(), end_date: getDate(), staff_id: '' }).then(res => {
													setSalaryCalcRepo(res.data);
													setLoad(false);
												}).catch(err => {
													setLoad(false);
												});
												setPage('report_salary_calc');
											});
										}}>Salary calculation report</div>
										<div className={`sidebar-subitem ${page === 'report_salary_pay' ? 'active' : ''}`} onClick={() => {
											handleSidebarItemClick(() => {
												setLoad(true);
												postCall('api/bnr/get/salary/payment/report/', { start_date: getDate(), end_date: getDate(), staff_id: '' }).then(res => {
													setSalaryPayRepo(res.data);
													setLoad(false);
												}).catch(err => {
													setLoad(false);
												});
												setPage('report_salary_pay');
											});
										}}>Salary Payment report</div> */}
									</div>
								</div>
							) : ''
						}
						{/* Business With us */}
						{
							user !== undefined ? (
								user.type === 'admin' ? (
									<div className={`sidebar-item ${page === 'business-with-us' ? 'active' : ''}`} onClick={() => {
										handleSidebarItemClick(() => {
											setPage('business-with-us');
											getCall(setGetLoad, 'api/e/get/active/leads/', setLeads);
										});
									}}>
										<i className="bi bi-graph-up-arrow me-2"></i> <span>Business With Us</span>
									</div>
								) : ''
							) : ''
						}
						{/* More Actions */}
						{
							user !== undefined ? (
								user.type === 'admin' ? (
									<div className="sidebar-dropdown-group">
										<div className={`sidebar-item has-submenu ${activeSubMenu === 'more' ? 'active' : ''}`} onClick={() => handleGroupClick('more')}>
											<i className="bi bi-three-dots me-2"></i> <span>More</span>
											<i className={`bi bi-chevron-down ms-auto transition-icon ${activeSubMenu === 'more' ? 'rotate-180' : ''}`}></i>
										</div>
										<div className={`sidebar-submenu ${activeSubMenu === 'more' ? 'show' : ''}`}>
											{/* <div className={`sidebar-subitem ${page === 'verify_day_close' ? 'active' : ''}`} onClick={() => {
												handleSidebarItemClick(() => {
													setPage('verify_day_close');
													getDayCloseToVerify();
												});
											}}>Verify Day close</div>
											<div className={`sidebar-subitem ${page === 'special_token' ? 'active' : ''}`} onClick={() => {
												handleSidebarItemClick(() => {
													setPage('special_token');
													getTokenServices();
													getTokenCustomers();
													getSpecialTokens();
												});
											}}>Special Tokens</div>
											<div className={`sidebar-subitem ${page === 'special_bills' ? 'active' : ''}`} onClick={() => {
												handleSidebarItemClick(() => {
													getSpecialBills();
													getTokenServices();
													getTokenCustomers();
													setPage('special_bills');
												});
											}}>Special Bills</div> */}
											<div className={`sidebar-subitem ${page === 'payment_methods' ? 'active' : ''}`} onClick={() => {
												handleSidebarItemClick(() => {
													getPaymentMethods();
													setPage('payment_methods');
												});
											}}>Payment methods</div>
											<div className={`sidebar-subitem ${page === 'pay_wallet' ? 'active' : ''}`} onClick={() => {
												handleSidebarItemClick(() => {
													setPage('pay_wallet');
													getCall(setGetLoad, 'api/pw/get/wallet/', setPayWallet);
												});
											}}>Payment Wallets</div>
											<div className={`sidebar-subitem ${page === 'exp_parti' ? 'active' : ''}`} onClick={() => {
												handleSidebarItemClick(() => {
													setPage('exp_parti');
													getCall(setGetLoad, 'api/em/get/expense/particular/', setExpenseParti);
												});
											}}>Expense Particulars</div>
											<div className={`sidebar-subitem ${page === 'enquiry_types' ? 'active' : ''}`} onClick={() => {
												handleSidebarItemClick(() => {
													setPage('enquiry_types');
													getCall(setGetLoad, 'api/e/get/enquiry/types/', setEnquiryTypes);
												});
											}}>Enquiry Types</div>
										</div>
									</div>
								) : (
									<div className="sidebar-dropdown-group">
										<div className={`sidebar-item has-submenu ${activeSubMenu === 'more' ? 'active' : ''}`} onClick={() => handleGroupClick('more')}>
											<i className="bi bi-three-dots me-2"></i> <span>More</span>
											<i className={`bi bi-chevron-down ms-auto transition-icon ${activeSubMenu === 'more' ? 'rotate-180' : ''}`}></i>
										</div>
										<div className={`sidebar-submenu ${activeSubMenu === 'more' ? 'show' : ''}`}>
											{/* {
												user.permission.special_token !== undefined && Object.values(user.permission.special_token).indexOf(true) !== -1 && user.permission.special_token.A ? (
													<div className={`sidebar-subitem ${page === 'special_token' ? 'active' : ''}`} onClick={() => {
														handleSidebarItemClick(() => {
															setPage('special_token');
															getTokenServices();
															getTokenCustomers();
															getSpecialTokens();
														});
													}}>Special Tokens</div>
												) : ''
											}
											{
												user.permission.special_bill !== undefined && Object.values(user.permission.special_bill).indexOf(true) !== -1 && user.permission.special_bill.A ? (
													<div className={`sidebar-subitem ${page === 'special_bills' ? 'active' : ''}`} onClick={() => {
														handleSidebarItemClick(() => {
															getSpecialBills();
															getTokenServices();
															getTokenCustomers();
															setPage('special_bills');
														});
													}}>Special Bills</div>
												) : ''
											} */}
										</div>
									</div>
								)
							) : ''

						}

						{/* Profile / Logout Section moved to bottom or integrated */}
						<div className="sidebar-dropdown-group mt-auto">
							<div className="sidebar-item has-submenu" onClick={() => handleGroupClick('profile')}>
								<i className="bi bi-person-circle me-2"></i> <span>{
									user !== undefined ? (
										user.profile.first_name !== undefined ? user.profile.first_name : 'Username'
									) : 'Username'
								}</span>
								<i className={`bi bi-chevron-down ms-auto transition-icon ${activeSubMenu === 'profile' ? 'rotate-180' : ''}`}></i>
							</div>
							<div className={`sidebar-submenu ${activeSubMenu === 'profile' ? 'show' : ''}`}>
								{
									stateSettle !== undefined && stateSettleAll !== undefined ? (
										stateSettle && stateSettleAll ? (
											dayClose ? (
												<div className="sidebar-subitem" onClick={() => { setDayCloseModal(true) }}>
													Close Day
												</div>
											) : (
												<div className="sidebar-subitem" onClick={() => { getDayReport() }}>
													Day report
												</div>
											)
										) : (
											<div className="sidebar-subitem disabled">
												Close Day
											</div>
										)
									) : ''
								}
								{
									user !== undefined ? (
										user.type === 'admin' ? (
											<div className="sidebar-subitem" onClick={() => { setProfileModal(true) }}>
												Update profile
											</div>
										) : ''
									) : ''
								}
								<div className="sidebar-subitem" onClick={() => { setChangePasswordModal(true) }}>
									Change password
								</div>
								<div className="sidebar-subitem text-danger" onClick={() => {
									localStorage.clear();
									window.location.reload();
								}}>
									Log out
								</div>
							</div>
						</div>

					</div>
				</div>
			</div >
			<Modal show={profileModal} size="xl" onHide={() => { setProfileModal(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Update Profile</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={updateProfile} >
						<Form.Group className="mb-3" >
							<Form.Label>Center name {nameReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control defaultValue={account !== undefined ? account.name : ''} className="br-2 shadow-none" type="text" name="name" placeholder="Akshaya center name" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Email {emailReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control defaultValue={account !== undefined ? account.email : ''} className="br-2 shadow-none" type="email" name="email" placeholder="Email Id" />
						</Form.Group>

						{
							account !== undefined ? (
								account.logo !== "" && account.logo !== null && !changeLogo ? (
									<div className="show-logo br-3 bdr2 p-1">
										<img src={account.logo} style={{ maxWidth: '250px', maxHeight: '250px' }} />
										<Button onClick={() => { setChangeLogo(true) }} variant="secondary" className='mx-3 shadow-none br-2' >Change logo</Button>
									</div>
								) : (
									<Form.Group className="mb-3">
										<Form.Label>Logo {
											account.logo !== "" && account.logo !== null && changeLogo ? (
												<Button onClick={() => { setChangeLogo(false) }} variant="secondary" className='mx-3 shadow-none br-2' >Use old logo</Button>
											) : ''
										}{logoReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
										<Form.Control name="logo" type="file" className="br-2 shadow-none" accept=".png, .jpg, .jpeg" />
									</Form.Group>
								)
							) : ''
						}

						<Form.Group className="mb-3">
							<Form.Label>Address {addressReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control defaultValue={account !== undefined ? account.address : ''} className="br-2 shadow-none" as="textarea" rows="3" name="address" placeholder="Address" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Contact details {contactReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control defaultValue={account !== undefined ? account.phone_numbers : ''} className="br-2 shadow-none" as="textarea" rows="3" name="contact" placeholder="Eg: phone:+91 1234567890, +91 9874563210, Email : example@mail.com" />
						</Form.Group>
						<div className="d-grid">
							{
								profileUpdateLoad ? (
									<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="br-2 shadow-none btn-t1" >Update</Button>
								)
							}
						</div>
					</Form>
				</Modal.Body>
				<Modal.Footer>

				</Modal.Footer>
			</Modal>

			<Modal show={dayCloseModal} backdrop="static" size="xl" onHide={() => { setDayCloseModal(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Add Denomination  in hand</Modal.Title>
				</Modal.Header>
				{
					dayCloseState !== undefined ? (
						dayCloseState === 'denomination' ? (
							<Modal.Body>
								<Form onSubmit={addDenominations} >
									<Row >
										<Col xs={12} sm={12} md={12} className="mb-3">
											<InputGroup className="mb-3 br-2">
												<InputGroup.Text >Opening Balance</InputGroup.Text>
												<Form.Control name="opening" type="number" min="0" />
											</InputGroup>
										</Col>
										<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
											<InputGroup className="mb-3 br-2">
												<InputGroup.Text >500</InputGroup.Text>
												<Form.Control name="n_500" type="number" min="0" />
											</InputGroup>
										</Col>
										<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
											<InputGroup className="mb-3 br-2">
												<InputGroup.Text >200</InputGroup.Text>
												<Form.Control name="n_200" type="number" min="0" />
											</InputGroup>
										</Col>
										<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
											<InputGroup className="mb-3 br-2">
												<InputGroup.Text >100</InputGroup.Text>
												<Form.Control name="n_100" type="number" min="0" />
											</InputGroup>
										</Col>
										<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
											<InputGroup className="mb-3 br-2">
												<InputGroup.Text >50</InputGroup.Text>
												<Form.Control name="n_50" type="number" min="0" />
											</InputGroup>
										</Col>
										<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
											<InputGroup className="mb-3 br-2">
												<InputGroup.Text >20</InputGroup.Text>
												<Form.Control name="n_20" type="number" min="0" />
											</InputGroup>
										</Col>
										<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
											<InputGroup className="mb-3 br-2">
												<InputGroup.Text >10</InputGroup.Text>
												<Form.Control name="n_10" type="number" min="0" />
											</InputGroup>
										</Col>
										<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
											<InputGroup className="mb-3 br-2">
												<InputGroup.Text >5</InputGroup.Text>
												<Form.Control name="n_5" type="number" min="0" />
											</InputGroup>
										</Col>
										<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
											<InputGroup className="mb-3 br-2">
												<InputGroup.Text >2</InputGroup.Text>
												<Form.Control name="n_2" type="number" min="0" />
											</InputGroup>
										</Col>
										<Col xs={12} sm={6} md={4} lg={3} className="mb-3">
											<InputGroup className="mb-3 br-2">
												<InputGroup.Text >1</InputGroup.Text>
												<Form.Control name="n_1" type="number" min="0" />
											</InputGroup>
										</Col>
										<div className="d-grid">
											{
												addDenominationLoad ? (
													<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
												) : (
													<Button type='submit' className="btn-t1">CLOSE DAY</Button>
												)
											}
										</div>
									</Row>
								</Form>
							</Modal.Body>
						) : dayCloseState === 'addReason' ? (
							<Modal.Body>
								<Row>
									<Col xs={12} sm={6} md={3} lg={2} className="mb-3"  >
										<span className="f16 d-grid tp2 py-2 px-3 diff bdr1 br-3" >{closeDayReport !== undefined ? `Diffrence = ${closeDayReport.main.diffrence}` : ''}</span>
									</Col>
									<Col xs={12} sm={6} md={4} lg={3} className="mb-3"  >
										<span className="f16 d-grid tp2 py-2" >{closeDayReport !== undefined ? `Closing total = ${closeDayReport.main.denomination_total}` : ''}</span>
									</Col>
									<Col xs={12} sm={6} md={4} lg={3} className="mb-3"  >
										<span className="f16 d-grid tp2 py-2" >{closeDayReport !== undefined ? `Total Cash Settled = ${closeDayReport.main.primary_total}` : ''}</span>
									</Col>
								</Row>
								<Row>
									<span className="d-grid f18 tp2 py-2" >Submitted denominations</span>
									{
										closeDayReport !== undefined ? (
											closeDayReport.deno_values !== undefined ? (
												<>
													{
														closeDayReport.deno_values.n_500 > 0 ? (

															<Col xs={12} sm={6} md={4} lg={3}>
																<Col className="mb-3 denomin bdr2 px-0">
																	<span className="denomin-name bgs1 p-2" ><i className="bi bi-currency-rupee"></i> 500</span>
																	<span className="denomin-val p-2">{closeDayReport.deno_values.n_500} <span className="ts3 f14" >Numbers</span></span>
																</Col>
															</Col>
														) : ''
													}
													{
														closeDayReport.deno_values.n_200 > 0 ? (
															<Col xs={12} sm={6} md={4} lg={3}>
																<Col className="mb-3 denomin bdr2 px-0">
																	<span className="denomin-name bgs1 p-2" ><i className="bi bi-currency-rupee"></i> 200</span>
																	<span className="denomin-val p-2">{closeDayReport.deno_values.n_200} <span className="ts3 f14" >Numbers</span></span>
																</Col>
															</Col>
														) : ''
													}
													{
														closeDayReport.deno_values.n_100 > 0 ? (
															<Col xs={12} sm={6} md={4} lg={3}>
																<Col className="mb-3 denomin bdr2 px-0">
																	<span className="denomin-name bgs1 p-2" ><i className="bi bi-currency-rupee"></i> 100</span>
																	<span className="denomin-val p-2">{closeDayReport.deno_values.n_100} <span className="ts3 f14" >Numbers</span></span>
																</Col>
															</Col>
														) : ''
													}
													{
														closeDayReport.deno_values.n_50 > 0 ? (
															<Col xs={12} sm={6} md={4} lg={3} xl={3}>
																<Col className="mb-3 denomin bdr2 px-0">
																	<span className="denomin-name bgs1 p-2" ><i className="bi bi-currency-rupee"></i> 50</span>
																	<span className="denomin-val p-2">{closeDayReport.deno_values.n_50} <span className="ts3 f14" >Numbers</span></span>
																</Col>
															</Col>
														) : ''
													}
													{
														closeDayReport.deno_values.n_20 > 0 ? (
															<Col xs={12} sm={6} md={4} lg={3}>
																<Col className="mb-3 denomin bdr2 px-0">
																	<span className="denomin-name bgs1 p-2" ><i className="bi bi-currency-rupee"></i> 20</span>
																	<span className="denomin-val p-2">{closeDayReport.deno_values.n_20} <span className="ts3 f14" >Numbers</span></span>
																</Col>
															</Col>
														) : ''
													}
													{
														closeDayReport.deno_values.n_10 > 0 ? (
															<Col xs={12} sm={6} md={4} lg={3}>
																<Col className="mb-3 denomin bdr2 px-0">
																	<span className="denomin-name bgs1 p-2" ><i className="bi bi-currency-rupee"></i> 10</span>
																	<span className="denomin-val p-2">{closeDayReport.deno_values.n_10} <span className="ts3 f14" >Numbers</span></span>
																</Col>
															</Col>
														) : ''
													}
													{
														closeDayReport.deno_values.n_5 > 0 ? (
															<Col xs={12} sm={6} md={4} lg={3}>
																<Col className="mb-3 denomin bdr2 px-0">
																	<span className="denomin-name bgs1 p-2" ><i className="bi bi-currency-rupee"></i> 5</span>
																	<span className="denomin-val p-2">{closeDayReport.deno_values.n_5} <span className="ts3 f14" >Numbers</span></span>
																</Col>
															</Col>
														) : ''
													}
													{
														closeDayReport.deno_values.n_2 > 0 ? (
															<Col xs={12} sm={6} md={4} lg={3}>
																<Col className="mb-3 denomin bdr2 px-0">
																	<span className="denomin-name  bgs1 p-2" ><i className="bi bi-currency-rupee"></i> 2</span>
																	<span className="denomin-val p-2">{closeDayReport.deno_values.n_2} <span className="ts3 f14" >Numbers</span></span>
																</Col>
															</Col>
														) : ''
													}
													{
														closeDayReport.deno_values.n_1 > 0 ? (
															<Col xs={12} sm={6} md={4} lg={3}>
																<Col className="mb-3 denomin bdr2 px-0">
																	<span className="denomin-name bgs1 p-2" ><i className="bi bi-currency-rupee"></i> 1</span>
																	<span className="denomin-val p-2">{closeDayReport.deno_values.n_1} <span className="ts3 f14" >Numbers</span></span>
																</Col>
															</Col>
														) : ''
													}
												</>
											) : ''
										) : ''
									}
								</Row>
								<Form className="mb-3" onSubmit={submitReason} >
									<Form.Group className="mb-3" >
										<Form.Label className="f16 tp2" >Please enter the reason for diffrence in cash.</Form.Label>
										<Form.Control as="textarea" className="shadow-none br-2" name="reason" />
									</Form.Group>
									<div className="d-grid">
										{
											reasonSubmitLoad ? (
												<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
											) : (
												<Button type="submit" className="btn-t1">Submit</Button>
											)
										}
									</div>
								</Form>
								<Row>
									<Col>
										<Accordion>
											<Accordion.Item eventKey="0">
												<Accordion.Header><span className="tp1 f18" >Bill details</span></Accordion.Header>
												<Accordion.Body>
													<Col>
														{
															closeDayReport !== undefined ? (
																closeDayReport !== undefined && closeDayReport.wallet_values !== undefined ? (
																	<>
																		<span className="d-grid f20 bgs1 bdr1 bdrb0 px-2 tp2 py-2" ><b>Wallet details</b></span>
																		<Table bordered className="tbl-bg-blue" >
																			<thead>
																				<tr>
																					<th><span className="tp2" >Date</span></th>
																					<th><span className="tp2" >Customer</span></th>
																					<th><span className="tp2" >Staff</span></th>
																					<th><span className="tp2" >Payment Methods</span></th>
																					<th className="text-end" ><span className="tp2" >Total</span></th>
																				</tr>
																			</thead>
																			<tbody>
																				{
																					Object.keys(closeDayReport.wallet_values).length > 0 ? (
																						Object.keys(closeDayReport.wallet_values).map((wc, wci) => (
																							<tr key={`wc_$wci`} className="tp2" >
																								<td>{closeDayReport.wallet_values[wc].collected_date}
																								</td>
																								<td>
																									<div className="d-grid">
																										<span className="tp2 f16" >{closeDayReport.wallet_values[wc].customer_name}</span>
																										<span className="tp2 f16" >{closeDayReport.wallet_values[wc].customer_phone}</span>
																									</div>
																								</td>
																								<td>
																									<div class="flex-wrap align-items-center justify-content-between bdrb2 mb-1 px-1" >
																										<span className="tp2 f16" >Collected by {closeDayReport.wallet_values[wc].cash_collected}</span>
																										<span className="tp2 f16 grid-justify-end" >{closeDayReport.wallet_values[wc].collected_time}</span>
																									</div>
																								</td>
																								<td>
																									<div className="d-grid">
																										{
																											closeDayReport.wallet_values[wc].ap_payments !== undefined ? (
																												Object.keys(closeDayReport.wallet_values[wc].ap_payments).length > 0 ? (
																													Object.keys(closeDayReport.wallet_values[wc].ap_payments).map((b_pay, b_pay_i) => (
																														<div class="flex-wrap align-items-center justify-content-between bdrb2 mb-1 px-1" key={`bpay_${b_pay_i}`} >
																															<span className="tp2 f16" >{closeDayReport.wallet_values[wc].ap_payments[b_pay].name}</span>
																															<span className="tp2 f16 grid-justify-end" >{closeDayReport.wallet_values[wc].ap_payments[b_pay].amount}</span>
																														</div>
																													))
																												) : ''
																											) : ''
																										}
																									</div>
																								</td>
																								<td className="text-end" >
																									{
																										closeDayReport.wallet_values[wc].amount > 0 ? (
																											<span className="sucess-text">{closeDayReport.wallet_values[wc].amount}</span>
																										) : (
																											<span className="error-text">{closeDayReport.wallet_values[wc].amount}</span>
																										)
																									}
																								</td>
																							</tr>
																						))
																					) : 'Wallet Not found!'
																				}
																				{
																					closeDayReport !== undefined ? (
																						closeDayReport.main.advance_total !== undefined ? (
																							Object.keys(closeDayReport.main.advance_total).length > 0 ? (
																								Object.keys(closeDayReport.main.advance_total).map((r_pay, r_pay_i) => (
																									closeDayReport.main.advance_total[r_pay].amount !== 0 ? (
																										<tr key={`r_pay_x${r_pay_i}`}>
																											<td colSpan={3} ></td>
																											<td className="text-end" ><span className="tp1 f16" >{closeDayReport.main.advance_total[r_pay].name}</span></td>
																											<td className="text-end" >
																												{
																													closeDayReport.main.advance_total[r_pay].amount > 0 ? (
																														<span className="sucess-text">{closeDayReport.main.advance_total[r_pay].amount}</span>
																													) : (
																														<span className="error-text">{closeDayReport.main.advance_total[r_pay].amount}</span>
																													)
																												}
																											</td>
																										</tr>
																									) : ''
																								))
																							) : ''
																						) : ''
																					) : ''
																				}
																				{
																					closeDayReport !== undefined ? (
																						closeDayReport.main !== undefined ? (
																							<tr>
																								<td colSpan={3} ></td>
																								<td className="text-end bgy" ><span className="tp1 f18" >Total</span></td>
																								<td className="text-end bgy" >{closeDayReport.main.advance_day_total}</td>
																							</tr>
																						) : ''
																					) : ''
																				}
																			</tbody>
																		</Table>
																	</>
																) : 'Wallet Not found!'
															) : ''
														}
														{
															closeDayReport !== undefined ? (
																closeDayReport.debit_values !== undefined && Object.keys(closeDayReport.debit_values).length > 0 ? (
																	<>
																		<span className="d-grid f18 tp2 py-2" >Credit details</span>
																		<Table bordered className="tbl-bg-blue" >
																			<thead>
																				<tr>
																					<th><span className="tp2" >Customer</span></th>
																					<th><span className="tp2" >Bill details</span></th>
																					<th><span className="tp2" >Times</span></th>
																					<th><span className="tp2" >Payment Methods</span></th>
																					<th className="text-end" ><span className="tp2" >Total</span></th>
																				</tr>
																			</thead>
																			<tbody>
																				{
																					Object.keys(closeDayReport.debit_values).map((debit, deb_i) => (
																						<tr key={`debi_${deb_i}`} >
																							<td>
																								<div className="d-grid">
																									<span className="tp2 f16" >{closeDayReport.debit_values[debit].customer_name}</span>
																									<span className="tp2 f16" >{closeDayReport.debit_values[debit].customer_phone}</span>
																								</div>
																							</td>
																							<td>
																								<div className="d-grid">
																									<span className="tp1 f16" >Token No : {closeDayReport.debit_values[debit].token_no}</span>
																									<span className="tp2 f16" >Bill No : {closeDayReport.debit_values[debit].bill_no}</span>
																									<span className="tp2 f16" >Date : {closeDayReport.debit_values[debit].collected_date}</span>
																								</div>
																							</td>
																							<td>
																								<div className="flex-wrap align-items-center justify-content-between bdrb2 mb-1 px-1" >
																									<span className="tp2 f16" >Collected</span>
																									<span className="tp2 f16 grid-justify-end" >{closeDayReport.debit_values[debit].collected_time}</span>
																								</div>
																							</td>
																							<td>
																								<div className="d-grid">
																									{
																										closeDayReport.debit_values[debit].debit_payments !== undefined ? (
																											Object.keys(closeDayReport.debit_values[debit].debit_payments).length > 0 ? (
																												Object.keys(closeDayReport.debit_values[debit].debit_payments).map((b_pay, b_pay_i) => (
																													<div className="flex-wrap align-items-center justify-content-between bdrb2 mb-1 px-1" key={`bpay_${b_pay_i}`} >
																														<span className="tp2 f16" >{closeDayReport.debit_values[debit].debit_payments[b_pay].name}</span>
																														<span className="tp2 f16 grid-justify-end" >{closeDayReport.debit_values[debit].debit_payments[b_pay].amount}</span>
																													</div>
																												))
																											) : ''
																										) : ''
																									}
																								</div>
																							</td>
																							<td className="text-end pos-rel" >
																								<span className="tp1 f18" >{closeDayReport.debit_values[debit].debit_total}</span>
																							</td>
																						</tr>
																					))
																				}
																				{
																					closeDayReport !== undefined ? (
																						closeDayReport.main.debit_total !== undefined ? (
																							Object.keys(closeDayReport.main.debit_total).length > 0 ? (
																								Object.keys(closeDayReport.main.debit_total).map((r_pay, r_pay_i) => (
																									closeDayReport.main.debit_total[r_pay].amount > 0 ? (
																										<tr key={`r_pay_${r_pay_i}`}>
																											<td colSpan={3} ></td>
																											<td className="text-end" ><span className="tp1 f16" >{closeDayReport.main.debit_total[r_pay].name}</span></td>
																											<td className="text-end" >{closeDayReport.main.debit_total[r_pay].amount}</td>
																										</tr>
																									) : ''
																								))
																							) : ''
																						) : ''
																					) : ''
																				}
																				{
																					closeDayReport !== undefined ? (
																						closeDayReport.main !== undefined ? (
																							<tr>
																								<td colSpan={3} ></td>
																								<td className="text-end bgy" ><span className="tp1 f18" >Total</span></td>
																								<td className="text-end bgy" >{closeDayReport.main.debit_amount_total}</td>
																							</tr>
																						) : ''
																					) : ''
																				}
																			</tbody>
																		</Table>
																	</>
																) : ''
															) : ''
														}
														<span className="d-grid f18 tp2 py-2" >Collection details</span>
														<Table bordered className="tbl-bg-blue" >
															<thead>
																<tr>
																	<th><span className="tp2" >Token</span></th>
																	<th><span className="tp2" >Services</span></th>
																	<th><span className="tp2" >Customer</span></th>
																	<th><span className="tp2" >Times</span></th>
																	<th><span className="tp2" >Payment Methods</span></th>
																	<th className="text-end" ><span className="tp2" >Total</span></th>
																</tr>
															</thead>
															<tbody>
																{
																	closeDayReport !== undefined ? (
																		closeDayReport.bill_values !== undefined ? (
																			Object.keys(closeDayReport.bill_values).map((tkn, tkn_i) => (
																				<tr key={`trep_${tkn_i}`} >
																					<td>
																						<div className="d-grid">
																							<span className="tp1 f18" >No : {closeDayReport.bill_values[tkn].token_no}</span>
																							<span className="tp2 f16" >Bill No : {closeDayReport.bill_values[tkn].bill_no}</span>
																						</div>
																					</td>
																					<td>
																						<div className="d-grid">
																							{
																								closeDayReport.bill_values[tkn].bill_services !== undefined ? (
																									Object.keys(closeDayReport.bill_values[tkn].bill_services).length > 0 ? (
																										Object.keys(closeDayReport.bill_values[tkn].bill_services).map((t_ser, t_ser_i) => (
																											<span className="tp2 f16" key={`tkrpt_${t_ser_i}`} >{closeDayReport.bill_values[tkn].bill_services[t_ser].service_name}{closeDayReport.bill_values[tkn].bill_services[t_ser].quantity !== undefined && closeDayReport.bill_values[tkn].bill_services[t_ser].quantity > 1 ? (<> ( {closeDayReport.bill_values[tkn].bill_services[t_ser].quantity} )</>) : ''}</span>
																										))
																									) : ''
																								) : ''
																							}
																						</div>
																					</td>
																					<td>
																						<div className="d-grid">
																							<span className="tp2 f16" >{closeDayReport.bill_values[tkn].customer_name}</span>
																							<span className="tp2 f16" >{closeDayReport.bill_values[tkn].customer_phone}</span>
																						</div>
																					</td>
																					<td>
																						<div className="d-grid">
																							<div className="flex-wrap align-items-center justify-content-between  bdrb2 mb-1 px-1">
																								<span className="tp2 f16" >Open</span>
																								<span className="tp2 f16 grid-justify-end" >{closeDayReport.bill_values[tkn].open_time}</span>
																							</div>
																							<div className="flex-wrap align-items-center justify-content-between bdrb2 mb-1 px-1">
																								<span className="tp2 f16" >Close</span>
																								<span className="tp2 f16 grid-justify-end" >{closeDayReport.bill_values[tkn].close_time}</span>
																							</div>
																						</div>
																					</td>
																					<td>
																						<div className="d-grid">
																							{
																								closeDayReport.bill_values[tkn].bill_payments !== undefined ? (
																									Object.keys(closeDayReport.bill_values[tkn].bill_payments).length > 0 ? (
																										Object.keys(closeDayReport.bill_values[tkn].bill_payments).map((b_pay, b_pay_i) => (
																											<div className="flex-wrap align-items-center justify-content-between bdrb2 mb-1 px-1" key={`bpay_${b_pay_i}`} >
																												<span className="tp2 f16" >{closeDayReport.bill_values[tkn].bill_payments[b_pay].name}</span>
																												<span className="tp2 f16 grid-justify-end" >{closeDayReport.bill_values[tkn].bill_payments[b_pay].amount}</span>
																											</div>
																										))
																									) : ''
																								) : ''
																							}
																						</div>
																					</td>
																					<td className="text-end pos-rel" >
																						<span className="tp1 f18" >{closeDayReport.bill_values[tkn].bill_total}</span>
																					</td>
																				</tr>
																			))
																		) : ''
																	) : ''
																}
																{
																	closeDayReport !== undefined ? (
																		closeDayReport.main.payments_total !== undefined ? (
																			Object.keys(closeDayReport.main.payments_total).length > 0 ? (
																				Object.keys(closeDayReport.main.payments_total).map((r_pay, r_pay_i) => (
																					closeDayReport.main.payments_total[r_pay].amount > 0 ? (
																						<tr key={`r_pay_${r_pay_i}`}>
																							<td colSpan={4} ></td>
																							<td className="text-end" ><span className="tp1 f16" >{closeDayReport.main.payments_total[r_pay].name}</span></td>
																							<td className="text-end" >{closeDayReport.main.payments_total[r_pay].amount}</td>
																						</tr>
																					) : ''
																				))
																			) : ''
																		) : ''
																	) : ''
																}
																{
																	closeDayReport !== undefined ? (
																		closeDayReport.main !== undefined ? (
																			<tr>
																				<td colSpan={4} ></td>
																				<td className="text-end bgy" ><span className="tp1 f18" >Total</span></td>
																				<td className="text-end bgy" >{closeDayReport.main.bill_amount_total}</td>
																			</tr>
																		) : ''
																	) : ''
																}
															</tbody>
														</Table>
														{
															closeDayReport !== undefined && closeDayReport.expense_values !== undefined && Object.keys(closeDayReport.expense_values).length > 0 ? (
																<>
																	<span className="d-grid f18 tp2 py-2" >Expense details</span>
																	<Table bordered className="tbl-bg-blue" >
																		<thead>
																			<tr>
																				<th className="tp2" >Particulars</th>
																				<th className="tp2" >Remarks</th>
																				<th className="tp2" >Staff</th>
																				<th className="tp2" >Payment method</th>
																				<th className="text-end tp2" >Amount</th>
																			</tr>
																		</thead>
																		<tbody>
																			{
																				Object.keys(closeDayReport.expense_values).map((exp, expi) => (
																					<tr key={`expi_${expi}`} className="tc2" >
																						<td>
																							<span className="d-grid" >{closeDayReport.expense_values[exp].particulars}</span>
																						</td>
																						<td>{closeDayReport.expense_values[exp].remarks}</td>
																						<td>{closeDayReport.expense_values[exp].user}</td>
																						<td>{closeDayReport.expense_values[exp].payment_type}</td>
																						<td className="text-end">{closeDayReport.expense_values[exp].expense_total}</td>
																					</tr>
																				))
																			}
																			<tr>
																				<td colSpan={3} className="tp2 text-end f20 f-400">Total</td>
																				<td>
																					{
																						closeDayReport.main.expense_total !== undefined && Object.keys(closeDayReport.main.expense_total).length > 0 ? (
																							Object.keys(closeDayReport.main.expense_total).map((ex, exi) => (
																								closeDayReport.main.expense_total[ex].amount > 0 ? (
																									<div class="flex-wrap align-items-center justify-content-between bdrb2 mb-1 px-1" key={`bpay_${exi}`} >
																										<span className="tp2 f16" >{closeDayReport.main.expense_total[ex].name}</span>
																										<span className="tp2 f16 grid-justify-end" >{closeDayReport.main.expense_total[ex].amount}</span>
																									</div>
																								) : ''
																							))
																						) : ''
																					}
																				</td>
																				<td className="text-end f20 f-400">{closeDayReport.main !== undefined ? closeDayReport.main.expense_day_total : ''}</td>
																			</tr>
																		</tbody>
																	</Table>
																</>
															) : ''
														}
													</Col>
												</Accordion.Body>
											</Accordion.Item>
										</Accordion>
									</Col>
								</Row>
							</Modal.Body>
						) : ''
					) : ''
				}
				<Modal.Footer>
				</Modal.Footer>
			</Modal>



			<Modal show={changePasswordModal} size="md" onHide={() => { setChangePasswordModal(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>
						{
							alertPassChange !== undefined ? (
								alertPassChange === 'default' ? (
									'Change password'
								) : alertPassChange === 'error' ? (
									<span className='error-alert'>Sothing went wrong</span>
								) : alertPassChange === 'sucess' ? (
									<span className="sucess-alert">Sucess</span>
								) : ''
							) : 'Change password'
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={changePassword} >
						<Form.Group className="mb-3" >
							<Form.Label>New Password {npassError ? (<span className="error-message" >This field is required</span>) : ''} {npassEqualError ? (<span className="error-message" >Password and Confirm password do not mach</span>) : ''}</Form.Label>
							<Form.Control className="shadow-none br-2" type="password" name="pass" placeholder="New Password" />
						</Form.Group>
						<Form.Group className="mb-3" >
							<Form.Label>Confirm Password {ncpassError ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
							<Form.Control className="shadow-none br-2" type="password" name="cpass" placeholder="Confirm Password" />
						</Form.Group>
						<div className="d-grid">
							{
								changePassLoad ? (
									<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="btn-t1">UPDATE</Button>
								)
							}
						</div>
					</Form>
				</Modal.Body>
			</Modal>
		</>
	)
}